export default "__VITE_ASSET__CeYlMbjR__"